import { render, staticRenderFns } from "./DescriptionTab.vue?vue&type=template&id=dc10bb18"
import script from "./DescriptionTab.vue?vue&type=script&lang=js"
export * from "./DescriptionTab.vue?vue&type=script&lang=js"
import style0 from "./DescriptionTab.vue?vue&type=style&index=0&id=dc10bb18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports